import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-expiration-date-cell',
  template: `<app-expiration-date [value]="value"></app-expiration-date>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpirationDateCellComponent implements ICellRendererAngularComp {
  private params: ICellRendererParams;
  public value: any;

  // called on init
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.value = this.params.value;
    return true;
  }
}
